import script from "./PostingEditLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostingEditLink.vue?vue&type=script&setup=true&lang=ts"

import "./PostingEditLink.vue?vue&type=style&index=0&id=636ec3b3&lang=postcss&scoped=true"

import exportComponent from "/home/runner/work/matchd-frontend/matchd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-636ec3b3"]])

export default __exports__